import dynamic from "next/dynamic";
import { Section } from "../index";

import {
  ServiceExampleGridWrapper,
  Image,
  PersonWrapperDesktop,
  PersonWrapperMobile,
} from "./styles";

const PersonDetail = dynamic(() =>
  import("../../elements/person-detail/person-detail")
);
const PriceItem = dynamic(() => import("../../elements/price-item/price-item"));

export const ServiceExample = ({
  sectionTitle,
  sectionSubtitle,
  hideLineSeparation,
  image,
  persons,
  price,
  displaySetting

}) => {
  const noPersonsBlock = persons.length === 0;

  return (
    <Section
      title={sectionTitle}
      subtitle={sectionSubtitle}
      hideLine={hideLineSeparation}
      displayMode={displaySetting?.displayMode}
      smallMargin={displaySetting?.smallBottomMargin}


    >
      <ServiceExampleGridWrapper>
        {image && <Image $span={noPersonsBlock} media={image} />}
        {!noPersonsBlock && (
          <PersonWrapperDesktop>
            <PersonDetail collection={persons} />
          </PersonWrapperDesktop>
        )}
        {price && <PriceItem {...price} />}
        {!noPersonsBlock && (
          <PersonWrapperMobile>
            <PersonDetail collection={persons} />
          </PersonWrapperMobile>
        )}
      </ServiceExampleGridWrapper>
    </Section>
  );
};

export default ServiceExample;
